import { render, staticRenderFns } from "./RelationFiltering.vue?vue&type=template&id=3d463fb5&scoped=true&"
import script from "./RelationFiltering.vue?vue&type=script&lang=js&"
export * from "./RelationFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d463fb5",
  null
  
)

export default component.exports